var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFEFE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9805 4.00098C12.9408 4.00098 4.00098 12.9608 4.00098 24.0005C4.00098 35.0402 12.9408 44 23.9805 44C35.0402 44 44 35.0402 44 24.0005C44 12.9608 35.0402 4.00098 23.9805 4.00098ZM26.0006 14.0016H22.0007V26.0013H26.0006V14.0016ZM26.0006 29.9998H22.0007V33.9997H26.0006V29.9998ZM8.0017 24.0013C8.0017 32.8411 15.1615 40.0009 24.0013 40.0009C32.8411 40.0009 40.0009 32.8411 40.0009 24.0013C40.0009 15.1615 32.8411 8.0017 24.0013 8.0017C15.1615 8.0017 8.0017 15.1615 8.0017 24.0013Z",
    fill: "#FF7800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileError);
export default __webpack_public_path__ + "static/media/file-error.d17cff1c.svg";
export { ForwardRef as ReactComponent };